import type { SessionSummary } from '@diana/contracts';

/** Cash actually recorded, never the quoted package price. Keep currencies separate. */
export function clientSummary(shoots: readonly SessionSummary[], clientId?: string) {
  const money = new Map<string, number>();
  let complete = true;
  const galleries = new Set<string>();
  let shootCount = 0,
    giftPurchases = 0;
  for (const shoot of shoots) {
    const gift = Boolean(clientId && shoot.isGiftCard && shoot.giftContacts);
    const isRecipient = !gift || shoot.giftContacts!.recipientId === clientId;
    const isBuyer = !clientId || !shoot.giftContacts || shoot.giftContacts.buyerId === clientId;
    if (isRecipient) shootCount++;
    if (gift && isBuyer) giftPurchases++;
    if (isBuyer && !shoot.transactions) complete = false;
    else if (isBuyer && shoot.transactions) {
      const net = shoot.transactions.reduce(
        (total, item) => total + (item.kind === 'Income' ? item.amountMinor : -item.amountMinor),
        0,
      );
      money.set(shoot.currency, (money.get(shoot.currency) ?? 0) + net);
    }
    if (isRecipient && shoot.galleryUrl?.trim())
      galleries.add(shoot.galleryUrl.trim().replace(/\/$/, ''));
  }
  return {
    shoots: shootCount,
    ...(clientId ? { giftPurchases } : {}),
    galleries: galleries.size,
    money: complete ? [...money.entries()].sort(([a], [b]) => a.localeCompare(b)) : null,
  };
}
